import { Modal } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Lottie from 'react-lottie';
import animationData from '../lotties/loading-white';

const useStyles = makeStyles(() => ({
  outerDiv: {
    transform: 'translateZ(1px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
  },
  innerDiv: {
    display: 'inline-block',
    width: '80px',
    height: '80px',
    margin: '8px'
  }
}));
const Loader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const classes = useStyles();
  return (
    <Modal open={true}>
      <div className={classes.outerDiv}>
        <div className={classes.innerDiv}>
          <Lottie options={defaultOptions} height={'100%'} width={'100%'} />
        </div>
      </div>
    </Modal>
  );
};

export default Loader;
